import type React from "react";
import { useTranslation } from "react-i18next";
import { STATS_COLORS } from "../../../types/graphStatsTypes";

interface GraphLegendProps {
  showNotVisited?: boolean;
}

const GraphLegend: React.FC<GraphLegendProps> = ({ showNotVisited = false }) => {
  const { t } = useTranslation();

  const legendItems: Array<{ color: string; label: string }> = [
    {
      color: STATS_COLORS.HIGH,
      label: t("statsNew.graph.legend.successHigh"),
    },
    {
      color: STATS_COLORS.MEDIUM,
      label: t("statsNew.graph.legend.successMedium"),
    },
    {
      color: STATS_COLORS.LOW,
      label: t("statsNew.graph.legend.successLow"),
    },
    {
      color: STATS_COLORS.NON_SCORED,
      label: t("statsNew.graph.legend.nonScored"),
    },
  ];

  if (showNotVisited) {
    legendItems.push({
      color: STATS_COLORS.NOT_VISITED,
      label: t("statsNew.graph.legend.notVisited"),
    });
  }

  return (
    <div className="flex flex-wrap items-center gap-4 text-sm">
      {legendItems.map((item, index) => (
        <div key={index} className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }} />
          <span className="text-gray-600">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default GraphLegend;
